// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1Pzty","label":"Category_label__5quD4","content":"Category_content__20v8X","header":"Category_header__Cy0VH","location":"Category_location__3z_7g"};